import { CdkTrapFocus } from '@angular/cdk/a11y';
import { AsyncPipe } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    OnInit,
} from '@angular/core';
import { isDefined } from '@interacta-shared/util';
import { CommunitiesStateService } from '@interacta/data-access-community-tree';
import { ICommunityCapabilities } from '@interacta/util-community';
import { GenericPost } from '@interacta/util-post';
import * as UISelectors from '@modules/core/store/UI/ui.selector';
import { Store } from '@ngrx/store';
import { concat, map, mergeMap, Observable, of } from 'rxjs';
import {
    distinctUntilChanged,
    filter,
    shareReplay,
    switchMap,
} from 'rxjs/operators';
import { PostCommentInputComponent } from '../post-comment-input/post-comment-input.component';

@Component({
    selector: 'interacta-comment-fullscreen-editor',
    templateUrl: './comment-fullscreen-editor.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PostCommentInputComponent, AsyncPipe, CdkTrapFocus],
})
export class CommentFullscreenEditorComponent implements OnInit {
    private readonly store = inject(Store);
    private readonly communitiesStateService = inject(CommunitiesStateService);

    post$!: Observable<GenericPost | null | undefined>;
    readonly commentFullScreenEditor = this.store.selectSignal(
        UISelectors.commentEditor,
    );
    communityCapabilities$!: Observable<ICommunityCapabilities | null>;

    ngOnInit(): void {
        this.post$ = concat(
            of(null),
            this.store.select(UISelectors.postIdOfFullscreenComment).pipe(
                filter((postId) => isDefined(postId)),
                distinctUntilChanged(),
                /* UISelectors.postOfFullscreenComment depends on PostSelectors.selectAllPosts, and 'communities' feature is 
                not yet loaded in store when CommentFullscreenEditorComponent is initialized */
                switchMap(() =>
                    this.store.select(UISelectors.postOfFullscreenComment),
                ),
            ),
        ).pipe(shareReplay(1));

        this.communityCapabilities$ = this.post$.pipe(
            mergeMap((post) =>
                post
                    ? this.communitiesStateService.getCommunity(
                          post.communityId,
                      )
                    : of(null),
            ),
            map((community) => community?.capabilities ?? null),
        );
    }
}
